import { Route } from '@angular/router';
import {
  CANTEEN_PROFILE_PAGE_CONFIG,
  PROFILE_PAGE_CONFIG,
} from 'components/profile/profile-page.config';
import { authGuard, guestGuard } from 'core/guards/auth.guard';
import { canteenRoleGuard } from './canteen-role.guard';
import { canteenShellGuard } from './canteen-shell.guard';

const staff = canteenRoleGuard(
  'CANTEEN_ADMIN',
  'CANTEEN_MANAGER',
  'CANTEEN_OPERATOR',
);
const catalog = canteenRoleGuard('CANTEEN_ADMIN', 'CANTEEN_MANAGER');
const reports = canteenRoleGuard('CANTEEN_ADMIN', 'CANTEEN_MANAGER');
const settings = canteenRoleGuard('CANTEEN_ADMIN');
const shoppers = canteenRoleGuard('GUARDIAN', 'STUDENT');

export const appRoutes: Route[] = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback').then((m) => m.AuthCallback),
  },
  {
    path: '',
    canActivate: [authGuard, canteenShellGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard').then((m) => m.CanteenDashboard),
      },
      {
        path: 'menu',
        canActivate: [shoppers],
        loadComponent: () =>
          import('./pages/menu/menu').then((m) => m.CanteenMenuPage),
      },
      {
        path: 'products',
        canActivate: [catalog],
        loadChildren: () =>
          import('./pages/products/products.routes').then(
            (m) => m.productRoutes,
          ),
      },
      {
        path: 'categories',
        canActivate: [catalog],
        loadChildren: () =>
          import('./pages/categories/categories.routes').then(
            (m) => m.categoryRoutes,
          ),
      },
      {
        path: 'pos',
        canActivate: [staff],
        loadComponent: () =>
          import('./pages/pos/pos').then((m) => m.CanteenPosPage),
      },
      {
        path: 'orders',
        loadComponent: () =>
          import('./pages/orders/orders').then((m) => m.CanteenOrdersPage),
      },
      {
        path: 'orders/:id',
        loadComponent: () =>
          import('./pages/orders/detail/order-detail').then(
            (m) => m.CanteenOrderDetailPage,
          ),
      },
      {
        path: 'pickup',
        canActivate: [staff],
        loadComponent: () =>
          import('./pages/pickup/pickup').then((m) => m.CanteenPickupPage),
      },
      {
        path: 'students',
        loadComponent: () =>
          import('./pages/students/students').then(
            (m) => m.CanteenStudentsPage,
          ),
      },
      {
        path: 'students/:id/statement',
        loadComponent: () =>
          import(
            './pages/students/detail/statement/student-statement-page'
          ).then((m) => m.CanteenStudentStatementPage),
      },
      {
        path: 'students/:id',
        loadComponent: () =>
          import('./pages/students/detail/student-detail').then(
            (m) => m.CanteenStudentDetailPage,
          ),
      },
      {
        path: 'inventory',
        canActivate: [staff],
        loadChildren: () =>
          import('./pages/inventory/inventory.routes').then(
            (m) => m.inventoryRoutes,
          ),
      },
      {
        path: 'cashier',
        canActivate: [staff],
        loadComponent: () =>
          import('./pages/cashier/cashier').then((m) => m.CanteenCashierPage),
      },
      {
        path: 'reports',
        canActivate: [reports],
        loadComponent: () =>
          import('./pages/reports/reports').then((m) => m.CanteenReportsPage),
      },
      {
        path: 'settings',
        canActivate: [settings],
        loadComponent: () =>
          import('./pages/settings/settings').then(
            (m) => m.CanteenSettingsPage,
          ),
      },
      {
        path: 'profile',
        providers: [
          {
            provide: PROFILE_PAGE_CONFIG,
            useValue: CANTEEN_PROFILE_PAGE_CONFIG,
          },
        ],
        loadChildren: () =>
          import('components/profile/profile.routes').then(
            (m) => m.profileRoutes,
          ),
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
];
